/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for TutorSubscriptionController controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_VERSUSCLIENT, CLIENT_CONTEXT_TOKEN_VERSUSCLIENT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { TutorSubscriberRequest, RequestOptions, TutorSubscriberDto } from "../models";

@Injectable({ providedIn: "root" })
export class TutorSubscriptionControllerService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_VERSUSCLIENT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_VERSUSCLIENT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'VersusClient');
    }

    subscribe(tutorSubscriberRequest: TutorSubscriberRequest, observe?: 'body', options?: RequestOptions<'json'>): Observable<TutorSubscriberDto>;
    subscribe(tutorSubscriberRequest: TutorSubscriberRequest, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<TutorSubscriberDto>>;
    subscribe(tutorSubscriberRequest: TutorSubscriberRequest, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<TutorSubscriberDto>>;
    subscribe(tutorSubscriberRequest: TutorSubscriberRequest, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/tutorat/subscriptions`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('post', url, {
            body: tutorSubscriberRequest,
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    computeMonthlyAmount(subscriberId: string, observe?: 'body', options?: RequestOptions<'text'>): Observable<number>;
    computeMonthlyAmount(subscriberId: string, observe?: 'response', options?: RequestOptions<'text'>): Observable<HttpResponse<number>>;
    computeMonthlyAmount(subscriberId: string, observe?: 'events', options?: RequestOptions<'text'>): Observable<HttpEvent<number>>;
    computeMonthlyAmount(subscriberId: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/tutorat/subscriptions/${subscriberId}/monthly`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            responseType: 'text',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findAllSubscriptionsByParent(parentId: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<Array<TutorSubscriberDto>>;
    findAllSubscriptionsByParent(parentId: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<Array<TutorSubscriberDto>>>;
    findAllSubscriptionsByParent(parentId: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<Array<TutorSubscriberDto>>>;
    findAllSubscriptionsByParent(parentId: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/tutorat/subscriptions/parent/${parentId}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findActiveSubscriptionsByParent(parentId: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<Array<TutorSubscriberDto>>;
    findActiveSubscriptionsByParent(parentId: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<Array<TutorSubscriberDto>>>;
    findActiveSubscriptionsByParent(parentId: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<Array<TutorSubscriberDto>>>;
    findActiveSubscriptionsByParent(parentId: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/tutorat/subscriptions/parent/${parentId}/active`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }
}
